<template>
  <div class="row">
    <div class="col-8">
      <autocomplete
        @selected="setMarket"
        @clear="removeMarket"
        :source="Object.values(templates)">
      </autocomplete>
    </div>
    <div class="col-4">
      <a href="javascript:;" @click="openTemplateModal()" class="btn btn-primary">+</a>
    </div>

    <sweet-modal ref="template" :title="t.create_template">
      <templateForm />
    </sweet-modal>
  </div>
</template>

<script>

  import templateForm from '@/components/feed/element/templateForm';
  import Autocomplete from 'vuejs-auto-complete'
  import Feed from '@/mixins/feed';

  export default {
    name: 'templateSelector',
    mixins: [Feed],
    components: {Autocomplete, templateForm},
    data () {
      return {
        t: this.$root.t,
        templates: null,
      }
    },
    props: {
      type: {
        default: 0,
        type: Number
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        this.fetchTemplates(this.type).then((d) => {
              this.templates = d.body;
        })
      },
      openTemplateModal() {
        this.$refs.template.open();
      },
      removeMarket() {
        this.$emit('clear', 0);
      },
      setMarket(e) {
        this.$emit('selected', e);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/feed/element/templateSelector.vue